export default {
  meta: {
    title: '智能体管理'
  }
};
